// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1QY5D","header":"PatientBlock_header__3armu","label":"PatientBlock_label__Mh3YL","option":"PatientBlock_option__3PJB8"};